/** Route gift search submissions through Shopify's native title index.
 * Existing broad-search and history links remain available without JavaScript.
 */
function matchingQuery(query) {
  if (/^title:/i.test(query)) return query;
  const words = query.normalize('NFKC').replace(/[’‘]/g, "'").match(/[\p{L}\p{N}]+(?:'[\p{L}\p{N}]+)*/gu) || [];
  if (!words.length || words.length > 12) return null;
  // Common connectors must remain unscoped: a quoted title-only 'of' can reject an existing compound name.
  const connectors = new Set(['of', 'the']);
  if (words.every((word) => connectors.has(word.toLowerCase()))) return null;
  return words.map((word) => connectors.has(word.toLowerCase()) ? word.toLowerCase() : `title:"${word}"`).join(' ');
}

function giftURL(url, query) {
  const scopedQuery = matchingQuery(query.trim());
  if (!scopedQuery) return null;
  url.searchParams.set('q', scopedQuery);
  url.searchParams.set('type', 'product');
  url.searchParams.delete('options[prefix]');
  url.searchParams.delete('page');
  return url;
}

document.addEventListener('submit', (event) => {
  const form = event.target;
  if (event.defaultPrevented || !(form instanceof HTMLFormElement) || !form.matches('form[role="search"]')) return;
  const url = new URL(form.action, location.origin);
  const searchPath = new URL(Theme.routes.search_url, location.origin).pathname;
  if (url.origin !== location.origin || url.pathname !== searchPath || form.method.toLowerCase() !== 'get') return;
  const data = new FormData(form);
  const type = data.get('type');
  if (type && type !== 'product') return;
  const query = data.get('q');
  if (typeof query !== 'string') return;
  url.search = new URLSearchParams(/** @type {any} */ (data)).toString();
  const destination = giftURL(url, query);
  if (!destination) return;
  event.preventDefault();
  location.assign(destination.toString());
});

// These are the existing autocomplete "View all" / suggested-query links only.
document.addEventListener('click', (event) => {
  if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
  const target = event.target;
  if (!(target instanceof Element)) return;
  const link = target.closest('a.cs-viewall, a.clan-result-viewall, .predictive-search-results__wrapper-queries a');
  if (!(link instanceof HTMLAnchorElement) || link.target || link.hasAttribute('download')) return;
  const url = new URL(link.href);
  if (url.origin !== location.origin || url.pathname !== new URL(Theme.routes.search_url, location.origin).pathname) return;
  const type = url.searchParams.get('type');
  if (type && type !== 'product') return;
  const destination = giftURL(url, url.searchParams.get('q') || '');
  if (!destination) return;
  event.preventDefault();
  location.assign(destination.toString());
});

const searchHeading = document.querySelector('[data-cag-search-title]');
if (searchHeading instanceof HTMLElement && searchHeading.dataset.cagSearchTitle) {
  document.title = searchHeading.dataset.cagSearchTitle;
}
